import { apiClient } from './client';

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('authToken') || localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getUsers = async (page = 1, pageSize = 20, search = '') => {
  const params = new URLSearchParams({ page: page.toString(), pageSize: pageSize.toString() });
  if (search) params.append('search', search);
  
  const response = await apiClient.get(`/users?${params}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createUser = async (payload) => {
  const response = await apiClient.post('/users', payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateUser = async (id, payload) => {
  const response = await apiClient.put(`/users/${id}`, payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await apiClient.delete(`/users/${id}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const inviteSingle = async (payload) => {
  const response = await apiClient.post('/users/inviteSingle', payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const assignAssessment = async (payload) => {
  const response = await apiClient.post('/admin/assign-assessment', payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const assignAssessmentBulk = async (payload) => {
  const response = await apiClient.post('/admin/assign-assessment', payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const inviteBulk = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await apiClient.post('/users/inviteBulk', formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// Admin only - Terminate customer and all associated data
export const terminateCustomer = async (customerId) => {
  const response = await apiClient.delete(`/users/customer/${customerId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Update user role with Firebase custom claims sync
export const updateUserRole = async (userId, role, customerId = null) => {
  const payload = { role };
  if (customerId) payload.customer_id = customerId;
  
  const response = await apiClient.put(`/users/${userId}`, payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};
